<template>
  <div class="companyInvitationFeedbackBox">
    <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
      <Form-item label="企业名称：" prop="companyName">
        <Input v-model="formCustom.companyName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="统一社会信用代码：" prop="organizationCode">
        <Input v-model="formCustom.organizationCode" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="行业类型：" prop="industryType">
        <Select v-model="formCustom.industryType" clearable filterable placeholder="请选择" style="width: 200px">
          <Option v-for="item in industryTypeList" :value="item.itemValue">{{ item.itemText }}</Option>
        </Select>
      </Form-item>
      <Form-item label="法人姓名：" prop="owner">
        <Input v-model="formCustom.owner" :maxlength="50" clearable placeholder="请输入" style="width: 200px"></Input>
      </Form-item>
      <Form-item label="企业注册地：" prop="countyCode">
        <Cascader v-model="formCustom.countyCode" :data="areaData" change-on-select filterable
                  not-found-text='暂无下级数据，请创建'
                  style="width: 200px" @on-change="changeCountyCode"></Cascader>
      </Form-item>
      <Form-item label="企业规模：" prop="companyScale">
        <Select v-model="formCustom.companyScale" clearable filterable placeholder="请选择" style="width: 200px">
          <Option v-for="item in companyScaleList" :value="item.itemValue">{{ item.itemText }}</Option>
        </Select>
      </Form-item>
      <Form-item label="状态：" prop="approvalStatus">
        <Select v-model="formCustom.approvalStatus" clearable filterable placeholder="请选择" style="width: 200px">
          <Option value="5">已邀请</Option>
          <Option value="6">同意邀请</Option>
          <Option value="7">拒绝邀请</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div>
      <Table :columns="companyInvitationFeedbackColumns" :data="companyInvitationFeedbackTableData" :loading="loading"
             aria-describedby="" aria-hidden="true" border>
        <template slot="countyName" slot-scope="{ row }">
          <span>{{ row.provinceName + row.cityName + row.countyName }}</span>
        </template>
        <template slot="approvalStatus" slot-scope="{ row }">
          <span>{{
              row.approvalStatus === 5 ? '已邀请' : row.approvalStatus === 6 ? '同意邀请' : row.approvalStatus === 7 ? '拒绝邀请' : '其他'
            }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button v-if="row.approvalStatus === 5" size="small" type="text"
                  @click="feedback(row.companyInvitationId, 6)">
            同意
          </Button>
          <Button v-if="row.approvalStatus === 5" size="small" type="text"
                  @click="feedback(row.companyInvitationId, 7)">
            拒绝
          </Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
  </div>
</template>

<script>
import permissionList from '@/libs/handlePermission.ts'
import {allDivisionTree} from '@/api/public'
import {companyInvitationFeedback, companyInvitationFeedbackPage} from '@/api/organization'
import {companyScaleList, industryTypeList} from "@/api/authority"

export default {
  name: 'companyInvitationFeedback',
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      formCustom: {
        companyName: '',
        organizationCode: '',
        owner: '',
        industryType: '',
        countyCode: [],
        companyScale: '',
        approvalStatus: ''
      },
      companyInvitationFeedbackColumns: [
        {type: 'index', title: '序号', align: 'center'},
        {title: '企业名称', key: 'companyName', align: 'center'},
        {title: '统一社会信用代码', key: 'organizationCode', align: 'center'},
        {title: '行业类型', key: 'industryTypeName', align: 'center'},
        {title: '法人姓名', key: 'owner', align: 'center'},
        {title: '企业注册地', key: 'countyName', slot: 'countyName', align: 'center'},
        {title: '企业规模(人)', key: 'companyScaleName', align: 'center'},
        {title: '状态', key: 'approvalStatus', slot: 'approvalStatus', align: 'center'},
        {title: '操作', slot: 'action', align: 'center', fixed: 'right'}
      ],
      companyInvitationFeedbackTableData: [], // 表格数据
      areaData: [],
      countyCode: '',
      industryTypeList: [], // 行业类型
      companyScaleList: [] // 企业规模
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      companyInvitationFeedbackPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res)
      })
      allDivisionTree().then((response) => {
        this.areaData = response.data.data
      })
      industryTypeList().then((response) => {
        this.industryTypeList = response.data.data
      })
      companyScaleList().then((response) => {
        this.companyScaleList = response.data.data
      })
    },
    // 查询
    handleSearch() {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      companyInvitationFeedbackPage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.companyInvitationFeedbackTableData = res.data.data.records
      this.loading = false
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    // 改变页码
    setCurrent(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.page = val
      companyInvitationFeedbackPage({
        current: val,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.pageSize = val
      companyInvitationFeedbackPage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    changeCountyCode(v, d) {
      this.countyCode = d.slice(-1)[0].id
    },
    // 反馈
    feedback(id, approvalStatus) {
      this.$Modal.confirm({
        title: approvalStatus === 6 ? '确认同意？' : '确认拒绝？',
        onOk: () => {
          companyInvitationFeedback({
            companyInvitationId: id,
            approvalStatus: approvalStatus
          }).then((res) => {
            this.$Message.success(res.data.msg)
            this.init()
          }).catch(() => {
            if (approvalStatus === '6') {
              this.$Message.error('同意失败')
            } else {
              this.$Message.error('拒绝失败')
            }
          })
        },
        onCancel: () => {
          if (approvalStatus === 6) {
            this.$Message.error('已取消同意')
          } else {
            this.$Message.error('已取消拒绝')
          }
        }
      })
    }
  }
}
</script>
<style lang="less">
.next {
  border-radius: 4px;
  background-color: rgba(0, 123, 211, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  height: 50px;
  border-color: #3A62D7;
  width: 80%
}
</style>
